import { Component, Input } from '@angular/core';
import { IDPrefix } from '../const';

enum IDPositionOptions { None = 0, After = 1, Before = 2 }

@Component({
  selector: 'jbm-label-with-ID',
  templateUrl: './JBMLabelWithID.component.html',
  styleUrls: ['./JBMLabelWithID.component.scss']
})
export class JBMLabelWithIDComponent {
  readonly IDPositionOptions = IDPositionOptions;

  @Input() label: string = '';
  @Input() ID: number | string | null = null;
  @Input() IDPrefix = IDPrefix;

  private _IDPosition: IDPositionOptions = IDPositionOptions.After;

  @Input()
  set IDPosition(value: IDPositionOptions | number | string | null | undefined) {
    if(value===undefined || value===null || value==='') {
      this._IDPosition = IDPositionOptions.After;
      return;
    }

    const numericValue = Number(value);
    this._IDPosition = isNaN(numericValue) ? IDPositionOptions.After : numericValue as IDPositionOptions;
  }
  get IDPosition(): IDPositionOptions {
    return this._IDPosition;
  }

  get hasID(): boolean {
    return this.ID !== null;
  }
}
